<template>
  <div class="rootTable">
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white">
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="搜索QQ号" class="mint-searchbar-core" style="color: black;margin-left: 5px"
                   v-model="searchKey" @input="search()"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div style="float: left;">
        <img src="../../../../assets/images/32/sort.png" style="margin-right:5px ;padding: 0" height="20px" width="20px"
             slot="icon" alt="" @click="showMenu">
      </div>
    </header>
    <div :style="classtest">
      <Loadmore :top-method="loadTop" :bottom-method="loadBottom" :auto-fill="false" ref="loadmore">
        <ul class="message-list">
          <li v-for="item in MessageList" :key="item.iD" class="message-item">
            <div class="message-header">
              <img :src="avatarSrc(item.guestQQ)" alt="头像" class="avatar"/>
              <div class="name-qq">
                <div class="name" v-html="item.name"></div>
                <div class="qq-number">{{ item.guestQQ }}</div>
              </div>
              <div class="time">{{ formatTimestamp(item.time) }}</div>
            </div>
            <div class="divider"></div>
            <div class="message-text" v-html="item.htmMessage"></div>
            <ul v-for="replyItem in item.reply" :key="replyItem.iD">
              <li>
                <div class="reply-container">
                  <div class="reply-header">
                    <div class="reply-name-container" v-html="replyItem.name"></div>
                    <span class="reply-time-container">{{ formatTimestamp(replyItem.time) }}</span>
                  </div>
                  <div class="reply-content">
                    <div v-html="replyItem.htmMessage" class="replyHtmMessage-container" @click="handleClick"></div>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </Loadmore>
    </div>
    <div>
      <span v-if="noMore">没有更多了...</span>
    </div>
    <div class="empty-div" v-if="showEmptyImage">
      <img src="../../../../assets/images/no_data.png" alt=""/>
      <Button size="large" class="backbutton" @click="goBackToLogin">注销登录</Button>
    </div>
    <vue-context-menu class="right-menu" :contextMenuData="contextMenuData"
                      @SortByTime="SortByTime"
                      @SortByTimeRevert="SortByTimeRevert"
                      @sortByCount="sortByCount"
                      @sortByCountRevert="sortByCountRevert"
                      @sortByReply="sortByReply"
                      @sortByLength="sortByLength"
                      style="margin: 2.55rem 0 0 0.8rem">
    </vue-context-menu>
  </div>
</template>

<script>
import {Indicator, Loadmore} from "mint-ui";

export default {
  name: "QzoneMessage",
  data() {
    return {
      searchKey: null,
      sortType: 1,
      contextMenuData: {
        //菜单显示的位置
        axis: {
          x: null,
          y: null,
        },
        //菜单选项
        menulists: [
          {
            fnHandler: "SortByTimeRevert",
            btnName: "按时间降序",
          },
          {
            fnHandler: "SortByTime",
            btnName: "按时间升序",
          },
          {
            fnHandler: "sortByCountRevert",
            btnName: "按数量降序",
          },
          {
            fnHandler: "sortByCount",
            btnName: "按数量升序",
          },
          {
            fnHandler: "sortByReply",
            btnName: "按回复排序",
          }, {
            fnHandler: "sortByLength",
            btnName: "按字数排序",
          },


        ],
      },
      Message: {
        guestQQ: null,
        hostQQ: null,
        htmMessage: null,
        iD: null,
        message: null,
        name: null,
        parentID: null,
        reply: null,
        time: null,
      },
      showEmptyImage: false,
      noMore: false,
      pageSize: 50,
      pageIndex: 1,
      qqAvatarUrl: '',
      MessageList: [],
      MessageList_Temp: [],
      getQQMessageUrl: '/api/qzone/getQQMessage',
      classtest: {
        marginTop: '30px',
        overflow: 'scroll',
        height: (document.documentElement.clientHeight).toString() + 'px',
      },
    }
  },
  mounted() {
    let loginQQ = localStorage.getItem('loginQQ')
    if (loginQQ !== null && loginQQ !== 'null' && loginQQ !== undefined) {
      this.getQQMessageFunction(true)
      this.$refs.loadmore.onTopLoaded();
    } else {
      this.$router.push('qzone_login')
    }
  },
  components: {
    Loadmore
  },
  methods: {
    search() {
      if (this.searchKey === null) {
        return
      }
      if (this.searchKey === '') {
        this.MessageList = this.MessageList_Temp
        return
      }
      let temp = []
      this.MessageList_Temp.forEach(item => {
        if (item.guestQQ && item.guestQQ.toString().includes(this.searchKey)) {
          temp.push(item)
        }
      })
      this.MessageList = temp
    },
    showMenu() {
      const x = document.documentElement.clientWidth
      const y = -15
      // Get the current location
      this.contextMenuData.axis = {
        x, y
      }
    },
    SortByTimeRevert() {
      if (this.sortType !== 1) {
        this.sortType = 1
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    SortByTime() {
      if (this.sortType !== 2) {
        this.sortType = 2
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    sortByCountRevert() {
      if (this.sortType !== 3) {
        this.sortType = 3
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    sortByCount() {
      if (this.sortType !== 4) {
        this.sortType = 4
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    sortByReply() {
      if (this.sortType !== 5) {
        this.sortType = 5
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    sortByLength() {
      if (this.sortType !== 6) {
        this.sortType = 6
        this.pageIndex = 1
      }
      this.getQQMessageFunction(false)
    },
    goBackToLogin() {
      localStorage.removeItem("loginSigData")
      localStorage.removeItem("QzoneloginSig")
      localStorage.removeItem("loginQQ")
      this.$router.push('qzone_login')
    },
    loadTop() {
      let that = this
      that.pageIndex = 1
      that.getQQMessageFunction(false)
      that.$refs.loadmore.onTopLoaded();
    },
    loadBottom() {
      if (this.noMore === true) {
        this.$refs.loadmore.onBottomLoaded();
        return;
      }
      this.getQQMessageFunction(true)
    },
    handleClick(event) {
      event.preventDefault();
    },
    getQzoneUrl(qq) {
      return " https://user.qzone.qq.com/" + qq
    },
    // 计算属性用于拼接完整的URL
    avatarSrc(qq) {
      return "https://q1.qlogo.cn/g?b=qq&nk=" + qq + "&s=100"
    },
    formatTimestamp(timestamp) {
      // 创建一个Date对象，传入毫秒级的时间戳
      const date = new Date(timestamp);

      // 提取并格式化各个日期时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getQQMessageFunction(isLoadmore) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getQQMessageUrl,
        params: {
          qq: localStorage.getItem('loginQQ'),
          pageIndex: that.pageIndex,
          pageSize: that.pageSize,
          sort: that.sortType
        }
      }).then((response) => {
        Indicator.close();
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          let list = response.data['responseData']
          that.showEmptyImage = list.length <= 0;
          if (that.pageIndex === 1) {
            that.MessageList = list
            that.MessageList_Temp = list
          } else {
            that.MessageList = that.MessageList.concat(list)
            that.MessageList_Temp = that.MessageList.concat(list)
          }
          let hasMore = list.length === that.pageSize
          if (hasMore) {
            that.pageIndex++
            that.noMore = false
          } else {
            that.noMore = true
          }
        }
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      }).catch(response => {
        Indicator.close();
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  height: 30px;
  width: 100%;
  line-height: var(--footer-height);
  background: #42b983;
  color: #fff;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .no-child-btn {
  font-size: 16px;
  color: white;
  font-family: 黑体, serif;
  background: #4C4C4C;
  padding-left: 0;
  padding-right: 0;
  border-bottom: solid 0.5px white;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .btn-wrapper-simple {
  height: 20px;
}

/deep/ .mint-loadmore {
  overflow: hidden;
  margin-top: 50px;
}

.right-menu {
  padding: 1.3rem 0 0 0;
  clip-path: polygon(90% 1%, 88% 11%, 100% 11%, 100% 100%, 0 100%, 0 11%, 78% 10%);
}

.rootTable {
  width: 100%;
  height: 100%;

  ul {
    list-style-type: none;
    margin: 0 0 0 2rem;

    li {
      margin-left: -2rem;
    }
  }

  /deep/ .vue-contextmenu-listWrapper {
    background: #4C4C4C;
  }


  .empty-div {
    position: absolute;
    left: 55%;
    top: 40%;
    transform: translate3d(-50%, -50%, 0);
  }

  a {
    text-decoration: none;
    color: blue;
  }
}

.popupstyle {
  width: 100px;
  height: 100px;

}

.backbutton {
  background: lightseagreen;
  margin: 2rem;
  height: 30px;
}

.rootDiv {

  ul {
    list-style-type: none;
    margin: 0;

    li {
      margin: 0;
    }
  }
}

.vertical-container {
  display: flex; /* 激活Flexbox布局模式 */
  flex-direction: column; /* 设定子元素垂直排列 */
  margin-top: 2px;
}

.header-container {
  display: flex; /* 激活Flexbox布局模式 */
  flex-direction: row; /* 设定子元素垂直排列 */
  background-color: lightblue;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 16px;
}

.htmMessage-container {
  display: flex;
  flex-direction: row;
  font-size: 22px;
  background-color: lightgoldenrodyellow;
  padding-left: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  min-height: 60px;
  text-align: left;
  align-items: center;
  width: 90%; /* 设置宽度为父容器的90% */
  max-width: 100%; /* 确保容器不超过屏幕宽度 */
  word-break: break-word; /* 自动换行 */
  white-space: normal; /* 允许正常换行 */
  box-sizing: border-box; /* 包括padding和border在内的宽度计算 */
}

.name-time-container {
  align-items: center;
  display: flex; /* 使用 Flexbox 布局 */
  flex-direction: column; /* 设置子元素水平排列 */
  margin-left: 20px;
}

.name-container {
  display: flex; /* 使用 Flexbox 布局 */
  text-align: left;
  font-size: 24px;
  color: green;
}

.time-container {
  display: flex; /* 使用 Flexbox 布局 */
  margin-top: 2px;
  text-align: left;
  font-size: 14px;
  color: black;
}

.circle-image {
  width: 48px; /* 或者你想要的宽度 */
  height: 48px; /* 和宽度相同 */
  border-radius: 50%; /* 使得div变成圆形 */
  overflow: hidden; /* 确保图片不会超出div范围 */
  position: relative; /* 用于定位img */
  margin-top: 5px;
}

.circle-image img {
  width: 100%;
  height: auto; /* 保持图片的宽高比 */
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%; /* 使得图片变成圆形 */
}
.message-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.message-item {
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.message-item:hover {
  transform: translateY(-2px);
}

.message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  padding: 15px;
  color: #fff;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-right: 10px;
}

.name-qq {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.name {
  font-weight: bold;
  font-size: 1.1em;
  color: #fff;
}

.qq-number {
  color: #ddd;
  font-size: 0.9em;
}

.time {
  color: #ccc;
  font-size: 0.9em;
  text-align: right;
}

.divider {
  height: 1px;
  background-color: #eee;
}

.message-text {
  background: linear-gradient(135deg, #f0f8ff, #e6f7ff);
  padding: 15px;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  font-size: 0.95em;
  line-height: 1.5;
  color: #333;
}

.reply-container {
  margin-bottom: 1px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.reply-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply-name-container {
  font-weight: bold;
  color: green;
  font-size: 1rem;
}

.reply-time-container {
  font-size: 0.8rem;
  color: black;
}

.reply-content {
  margin-top: 1px;
  text-align: left;
}

.replyHtmMessage-container {
  font-size: 1em;
}
</style>
